<template>
  <ButtonSquare
    :title="$t('general__view__indoorview')"
    :imgSource="require('@/assets/icon-indoorview.svg')"
    size="large"
    :activeState="activeState"
    :hoverButtons="hoverButtons"
    :hoverExplanationText="
      activeState === 'deactivated' && isIndoorviewShowing
        ? $t('general__text__loading')
        : 'undefined'
    "
    :activeHoverButtonValue="activeInstanceNumber"
    @clicked="handleIndoorviewButtonClick"
    @onHoverButtonClick="changeInstance"
    @mouseenter="onHover"
  />
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { INDOORVIEWER_PREFIX, MAPVIEW_PREFIX } from '@/store/module-prefixes'
import { CHANGE_PRIMARY_INSTANCE, CHANGE_SECONDARY_INSTANCE } from '@/store/mutation-types'
import { setViewToIndoorview, setViewToPreviousView } from '@/utils/views'
import { mapActions as mapActionsPinia } from 'pinia'
import { useGeneralStore } from '@/pinia'
import { zoomToEntities } from '@/composables/useMapbox'
export default {
  name: 'SelectBuildingIvionButton',
  components: {
    ButtonSquare
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    viewerNumber: {
      type: Number,
      default: 1
    }
  },
  emits: ['SelectBuildingIvionButtonHovered'],
  computed: {
    ...mapState({
      previousView: (state) => state.previousView,
      selectedRoom: (state) => state.selectedRoom
    }),
    ...mapState(MAPVIEW_PREFIX, {
      selectedBuilding: (state) => state.selectedBuilding
    }),
    ...mapState(INDOORVIEWER_PREFIX, {
      instanceLinks: (state) => state.instanceLinks,
      primaryInstance: (state) => state.primaryInstance,
      secondaryInstance: (state) => state.secondaryInstance
    }),
    ...mapGetters({ isIndoorviewShowing: 'isIndoorviewShowing' }),
    activeState() {
      if (!this.hoverButtons.length || this.disabled) return 'deactivated'
      return this.isIndoorviewShowing ? 'active' : 'inactive'
    },
    hoverButtons() {
      const hoverButtons = []
      this.instanceLinks.forEach((link, index) => {
        const title = link.title ?? `Site ${index + 1}`
        hoverButtons.push({
          title,
          emit: index.toString()
        })
      })
      return hoverButtons
    },
    activeInstanceNumber() {
      if (this.viewerNumber === 1)
        return this.primaryInstance ? this.primaryInstance.toString() : '0'
      return this.secondaryInstance ? this.secondaryInstance.toString() : '0'
    }
  },
  methods: {
    ...mapMutations(INDOORVIEWER_PREFIX, {
      changePrimaryInstance: CHANGE_PRIMARY_INSTANCE,
      changeSecondaryInstance: CHANGE_SECONDARY_INSTANCE
    }),
    ...mapActionsPinia(useGeneralStore, ['setShowFeature']),
    async handleIndoorviewButtonClick() {
      if (!this.instanceLinks.length || this.disabled) return
      if (!this.isIndoorviewShowing) {
        this.setShowFeature('featureInfo')
        setViewToIndoorview()
        return
      }
      await setViewToPreviousView(this.previousView)
      await new Promise((resolve) => setTimeout(resolve, 10))
      zoomToEntities([this.selectedBuilding.id])
    },
    onHover() {
      if (this.activeState !== 'deactivated') {
        this.$emit('SelectBuildingIvionButtonHovered')
      }
    },
    changeInstance(instanceNumber) {
      if (!this.isIndoorviewShowing) {
        this.setShowFeature('featureInfo')
      }
      if (instanceNumber === 'Missing data link') {
        return
      }
      if (this.viewerNumber === 1) {
        if (this.primaryInstance !== instanceNumber) {
          const instanceNr = parseInt(instanceNumber)
          this.changePrimaryInstance(instanceNr)
        }
      } else {
        if (this.secondaryInstance !== instanceNumber) {
          const instanceNr = parseInt(instanceNumber)
          this.changeSecondaryInstance(instanceNr)
        }
      }
      if (!this.isIndoorviewShowing) setViewToIndoorview()
    }
  }
}
</script>
